import { TableCell, styled, tableCellClasses } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme, sx }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.common.black,
    "&:first-of-type": {
      borderTopLeftRadius: "14px"
    },
    "&:last-of-type": {
      borderTopRightRadius: "14px"
    },
    "&:first-of-type:last-of-type": {
      borderTopLeftRadius: "14px",
      borderTopRightRadius: "14px"
    }
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    ...sx
  }
}));

export default StyledTableCell;
